import React from 'react';
import Parser from 'react-html-parser';
import Drawer from '@material-ui/core/Drawer';
import MenuBookRounded from '@material-ui/icons/MenuBookRounded';

import styles from './styles';
import classes from './classes.module.css';
import view from '../../../../Enums';
import IconButton from '../../../../ui-components/Button/Icon';
import Component from '../../../../ui-components/Component';
import { withResizer, withTranslations } from '../../../../HoCs';
import { isEmptyList, isEmptyString } from '../../../../utils';

class SideBar extends Component {

    styles = styles;

    state = {
        sidebar: false,
    };

    toggleSideBar = () => this.setState(pState => ({ sidebar: !pState.sidebar }));

    renderMenuButton = () => <>
        <IconButton onClick={this.toggleSideBar} backgroundColor='var(--theme-color)' rippleColor='white' style={this.gs('menu_button')}><MenuBookRounded style={this.gs('menu_icon')} /></IconButton>
        <Drawer anchor='left' open={this.state.sidebar} onClose={this.toggleSideBar}>{this.renderContainer()}</Drawer>
    </>;

    onItemClicked = (s_i, c_i) =>  this.setState({ sidebar: false }, () => this.props.onContentClicked(s_i, c_i));

    renderContentHeading = ({ content_heading }, c_i, s_i) => <div onClick={() => this.onItemClicked(s_i, c_i)}
        style={this.gs('content_heading_wrapper')} className={classes.contentHeadingWrapper}>
        <div style={this.gs('dot')} />
        <div style={this.gs('content_heading')}>{Parser(content_heading)}</div>
    </div>;

    renderSection = ({ sub_heading, contents_points: contents }, s_i) => <div key={s_i}>
        {!isEmptyString(sub_heading) && <div style={this.gs('section_heading')} className={classes.sectionHeading} onClick={() => this.onItemClicked(s_i)}>{Parser(sub_heading)}</div>}
        {!isEmptyList(contents) && contents.map((content, c_i) => this.props.isValidContentHeading(s_i, c_i) && this.renderContentHeading(content, c_i, s_i))}
    </div>;

    renderContainer = () => {
        const { heading, section_details: sections } = this.props.data;
        return <div style={this.gs('container')}>
            {!isEmptyString(heading) && <div style={this.gs('heading')}>{Parser(heading)}</div>}
            {!isEmptyList(sections) && sections.map(this.renderSection)}
            <div style={{ height: 100 }} />
        </div>;
    }

    render = () => this.getViewMode() == view.MOBILE ? this.renderMenuButton() : this.renderContainer();

}

export default withResizer(withTranslations(SideBar));